export const getPostalCodeLabel = (countryCode: string) => {
  if (countryCode === 'USA') {
    return 'ZIP code';
  }
  if (countryCode === 'GBR') {
    return 'Postcode';
  }
  return 'Postal code';
};
